import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { getLocalConsent, setLocalConsent } from "@/lib/consent";
import { useAuth } from "@/context/AuthContext";

export const ConsentBanner = () => {
  const { user } = useAuth();
  const [show, setShow] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [advertising, setAdvertising] = useState(false);

  useEffect(() => { setShow(!getLocalConsent()?.decided && !user); }, [user]);
  if (!show) return null;

  const save = (state) => { setLocalConsent({ ...state, decided: true }); setShow(false); };

  return (
    <div data-testid="consent-banner" className="fixed bottom-4 left-4 right-4 z-[60] mx-auto max-w-2xl rounded-2xl border border-white/10 bg-[#0F1621]/95 p-5 text-white shadow-2xl backdrop-blur-xl">
      <div className="flex items-start gap-3">
        <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-cyan-400" />
        <div className="flex-1">
          <p className="text-sm font-semibold">Your privacy choices</p>
          <p className="mt-1 text-xs leading-relaxed text-slate-400">
            We use essential cookies to keep you signed in. Analytics (Google Analytics) and advertising measurement (Meta Pixel) run <b>only if you opt in</b> below and are never used for users under 18.
            See our <Link to="/privacy" className="text-cyan-400 underline">Privacy Policy</Link>.
          </p>
          <div className="mt-3 flex flex-wrap gap-4 text-xs">
            <label className="flex items-center gap-2"><input data-testid="consent-analytics-toggle" type="checkbox" checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} className="accent-cyan-400" /> Analytics</label>
            <label className="flex items-center gap-2"><input data-testid="consent-advertising-toggle" type="checkbox" checked={advertising} onChange={(e) => setAdvertising(e.target.checked)} className="accent-cyan-400" /> Advertising measurement</label>
          </div>
          <div className="mt-4 flex flex-wrap gap-2">
            <button data-testid="consent-essential-only-btn" onClick={() => save({ analytics: false, advertising: false })}
              className="rounded-full border border-white/15 px-4 py-2 text-xs font-semibold hover:bg-white/5">Essential only</button>
            <button data-testid="consent-save-btn" onClick={() => save({ analytics, advertising })}
              className="rounded-full bg-cyan-400 px-4 py-2 text-xs font-bold text-[#041016] hover:bg-cyan-300">Save my choices</button>
          </div>
        </div>
      </div>
    </div>
  );
};
